import React from 'react'
import { FlatButton } from 'material-ui'
import { browserHistory } from 'react-router'
import { CardActions } from 'material-ui/Card'
import ContentFilter from 'material-ui/svg-icons/action/list'

const cardActionsStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
  padding: '14px 0',
  marginRight: -8
}

const Actions = (props) => (
  <div>
    <CardActions style={cardActionsStyle}>
      <FlatButton
        onClick={() => {
          browserHistory.goBack()
        }}
        icon={<ContentFilter />}
        title='Return to list'
      />
    </CardActions>
  </div>
)

export default Actions
